import { FigureMode, modeDefinitions } from "@/data/registry";

const styles: Record<FigureMode, string> = {
  MEASURED: "border-liberty-gold/70 text-liberty-gold",
  DIRECT: "border-sky-400/70 text-sky-300",
  "FIELD-VERIFIED": "border-amber-500/70 text-amber-400",
  MODELED: "border-muted-foreground/50 text-muted-foreground",
};

export function ModeBadge({ mode }: { mode: FigureMode }) {
  return (
    <span
      title={`${mode}: ${modeDefinitions[mode]}`}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.12em] ${styles[mode]}`}
    >
      {mode}
    </span>
  );
}
